export default "__VITE_ASSET__BVMpU_xu__"